import React, { useState } from "react";
import {
  Container,
  Dialog,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
import Slider from "react-slick";
import SheffieldHallam from "../../../../assets/images/schools/sheffield_hallam.svg";
import BirminghamCity from "../../../../assets/images/schools/Birmingham_city.jpeg";
import RobertGordon from "../../../../assets/images/schools/Robert_Gordon.jpeg";
import Fanshawe from "../../../../assets/images/schools/fanshawe.svg";
import Trent from "../../../../assets/images/schools/trent.svg";
import Conestoga from "../../../../assets/images/schools/conestoga.svg";
import Niagara from "../../../../assets/images/schools//niagara_falls.svg";
import Cambrian from "../../../../assets/images/schools/cambrian.svg";
import Texas from "../../../../assets/images/schools/texas_a&m.svg";
import Radford from "../../../../assets/images/schools/radford.svg";
import Illinois from "../../../../assets/images/schools/illinois.png";
import Pace from "../../../../assets/images/schools/pace.jpeg";
import Torrens from "../../../../assets/images/schools/torrens.svg";
import Catholic from "../../../../assets/images/schools/catholic.jpeg";
import Melbourne from "../../../../assets/images/schools/melbourne.jpeg";

const PartnerSchools = () => {
  const [open, setOpen] = useState(false);

  const partnerSchools = [
    { name: "Sheffield Hallam University", logo: SheffieldHallam },
    { name: "Birmingham City University", logo: BirminghamCity },
    { name: "Robert Gordon University", logo: RobertGordon },
    { name: "Fanshawe College", logo: Fanshawe },
    { name: "Trent University", logo: Trent },
    { name: "Conestoga College", logo: Conestoga },
    { name: "University of Niagara Falls", logo: Niagara },
    { name: "Cambrian College", logo: Cambrian },
    { name: "Texas A&M University", logo: Texas },
    { name: "Radford University", logo: Radford },
    { name: "University of Western Illinois", logo: Illinois },
    { name: "Pace University", logo: Pace },
    { name: "Torrens University", logo: Torrens },
    { name: "Australian Catholic University", logo: Catholic },
    { name: "Melbourne University of Technology", logo: Melbourne },
  ];

  const settings = {
    infinite: true,
    arrows: false,
    speed: 5000, // Slow scroll speed
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    pauseOnHover: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
    ],
  };

  return (
    <div>
      <Container>
        <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">
          Partner Schools
        </h2>
        <Slider {...settings}>
          {partnerSchools.map((school, index) => (
            <div key={index} className="flex items-center justify-center">
              <img
                src={school.logo}
                alt={school.name}
                className="w-40 h-20 object-contain"
              />
            </div>
          ))}
        </Slider>
        <div className="flex w-full justify-end items-center mt-10">
          <button
            className="underline text-primary px-8 transition-colors inline-flex items-center gap-2"
            onClick={() => setOpen(true)}
          >
            View all Schools
          </button>
        </div>
      </Container>

      {/* Modal for displaying all schools */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogContent>
          <Typography variant="h4" className="text-center mb-4">
            Partner Schools
          </Typography>
          <Grid container spacing={3}>
            {partnerSchools.map((school, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                <div className="flex flex-col items-center text-center">
                  <img
                    src={school.logo}
                    alt={school.name}
                    className="w-32 h-20 object-contain mb-2"
                  />
                  <Typography variant="body1">{school.name}</Typography>
                </div>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default PartnerSchools;
